import template from './deferralReviews.html';
import controller from './deferralReviewsCtrl.js';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    tab: '<',
    filterData: '<',
    dateSentFeature: '<',
    filterUpdateCount: '<',
    refreshCount: '<',
    onTableDataLoaded: '&',
    onSendModal: '&',
    viewContact: '&',
  },
};
